import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { DraggerIcon, IconPencil, IconTrash } from '../../../../utils/icons';
import * as Reorder from '../../../../components/dnd/Reorder';
import { IClient } from './constants';

interface Props {
  index: number;
  activity: IClient;
  onEdit: (index: number) => void;
  onRemove: (index: number) => void;
}

export default function SingleActivityEntry({
  index,
  activity,
  onEdit,
  onRemove,
}: Props) {
  const containerRef = useRef(null);

  return (
    <Box
      ref={containerRef}
      key={`profession-${index}`}
      className="flex gap-2 justify-between p-3 sm:p-4 border border-border-token rounded-lg"
    >
      <Typography className="w-[200px] truncate" fontFamily="CircularStdBlack">
        {activity.brand.name}
      </Typography>
      <Typography
        className="text-text-2 w-[200px] text-center truncate"
        fontFamily="CircularStd"
      >
        {moment(Number(activity?.date) || 0).format('MM/DD/YYYY')}
      </Typography>
      <Typography
        className="w-full text-text-2 text-center truncate"
        fontFamily="CircularStd"
      >
        {activity.notes}
      </Typography>
      {/* text-muted feeds the icons below via currentColor (SVG attrs can't take var()) */}
      <Box className="flex gap-2 items-center shrink-0 text-muted">
        <Box
          className="flex items-center justify-center cursor-pointer p-1"
          onClick={() => onEdit(index)}
        >
          <IconPencil size={18} stroke="currentColor" />
        </Box>
        <Box
          className="flex items-center justify-center cursor-pointer p-1"
          onClick={() => onRemove(index)}
        >
          <IconTrash width={18} height={18} stroke="currentColor" />
        </Box>
        <Reorder.Trigger index={index!} containerRef={containerRef}>
          <Box className="flex items-center justify-center cursor-pointer">
            <DraggerIcon size={26} stroke="currentColor" />
          </Box>
        </Reorder.Trigger>
      </Box>
    </Box>
  );
}
